import { RmsAccountDetailsComponentContainer } from '@/ui/features/accounts/components/RmsAccountDetailsComponentContainer';
import { useSlideout } from '@/ui/hooks';
import { CredentialingContextProvider } from '@juvare/credentialing/ui/providers';
import React from 'react';
import { useSearchParams } from 'react-router';

export const CredentialingProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
    const { selectedPersonId, menuItems, handlePersonIdSelect } = useSlideout();
    const [, setSearchParams] = useSearchParams();

    const handleResetPerson = () => {
        setSearchParams(
            (prev) => {
                const params = new URLSearchParams(prev);
                params.delete('id');
                return params;
            },
            { replace: true },
        );
    };

    return (
        <CredentialingContextProvider
            personId={selectedPersonId}
            personDetailsComponent={(props) => (
                <RmsAccountDetailsComponentContainer accountId={props.accountId} onClose={handleResetPerson} menuItems={menuItems} />
            )}
            slideoutMenuItems={menuItems}
            onPersonSelect={handlePersonIdSelect}
            onPersonReset={handleResetPerson}
        >
            {children}
        </CredentialingContextProvider>
    );
};
